// Fund data — copy verbatim from DAKSFIRST_FACTS_LEDGER_v1.md GREEN section (G6, G7, G8).
// Do not edit numbers without updating the ledger first.

export const funds = [
  {
    slug: "cayman",
    eyebrow: "Cayman",
    title: "Emerging and Frontier Markets fund",
    headline: "$100m",
    headlineSub: "target",
    description:
      "A Cayman-domiciled fund with a mandate to manage Emerging and Frontier Markets investments under the aegis of Daksfirst Limited.",
    tag: "Cayman Islands",
    facts: [
      ["Domicile", "Cayman Islands"],
      ["Strategy", "Emerging and Frontier Markets credit"],
      ["Manager", "Daksfirst Limited (UK)"],
      ["Target size", "$100m"],
      ["Auditor", "Moore"],
      ["Administrator", "NAV Fund Services"],
      ["Legal", "Maples and Calder"],
      ["Banker", "CIBC"],
      ["Investor type", "Professional and institutional only"]
    ]
  },
  {
    slug: "luxembourg",
    eyebrow: "Luxembourg",
    title: "Feeder vehicle",
    headline: "Segregated",
    headlineSub: "compartments",
    description:
      "A Luxembourg feeder vehicle into the Indian AIF and other European investments, with segregated compartments for different investors.",
    tag: "Segregated compartments",
    facts: [
      ["Domicile", "Luxembourg"],
      ["Type", "Feeder vehicle with segregated compartments"],
      ["Underlying", "Indian AIF + European investments"],
      ["Auditor", "PwC"],
      ["Administrator", "Maples FS"],
      ["Legal", "Maples and Calder"],
      ["Structuring", "EY"],
      ["Banker", "Citibank"],
      ["Investor type", "Professional and institutional only"]
    ]
  },
  {
    slug: "india",
    eyebrow: "India",
    title: "Daksfirst India Special Situations Fund I",
    headline: "~$200m",
    headlineSub: "fund size",
    description:
      "Category II Alternative Investment Fund registered with the Securities and Exchange Board of India.",
    tag: "SEBI Cat II AIF",
    facts: [
      ["Regulator", "SEBI"],
      ["Category", "Cat II Alternative Investment Fund"],
      ["Strategy", "Indian special situations credit"],
      ["Fund size", "~$200m"],
      ["Office", "Mumbai"],
      ["Administrator", "Daksfirst Advisors Private Limited"],
      ["Legal", "IC Legal"],
      ["Security trustee", "Vistra"],
      ["Registrar", "KFIN"],
      ["Structuring", "EY"],
      ["Bankers", "HDFC / ICICI"]
    ]
  }
];
